/** Captures UTM on first load and fires GA4 page_view + homepage_view events. */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { captureUtmFromUrl, trackEvent } from "@/lib/analytics";

const AnalyticsTracker = () => {
  const location = useLocation();

  // Capture UTM once on mount
  useEffect(() => {
    captureUtmFromUrl();
  }, []);

  // Fire page_view + a dedicated homepage_view on landing
  useEffect(() => {
    const path = location.pathname;
    trackEvent("page_view", { page_path: path });
    if (path === "/") trackEvent("homepage_view");
  }, [location.pathname]);

  return null;
};

export default AnalyticsTracker;
